var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighlight1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63478 24.2885C5.45594 23.6654 3.17476 23.3511 0.961871 23.0632C0.485249 23.0028 0.0427376 23.3396 0.00869311 23.8142C-0.0593958 24.2892 0.281248 24.7235 0.723826 24.7839C2.86863 25.0611 5.08131 25.3577 7.15802 25.9576C7.6006 26.0877 8.07742 25.8198 8.2136 25.3591C8.34978 24.8987 8.07736 24.4189 7.63478 24.2885Z",
    fill: "#A8C956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2396 15.4545C10.733 11.808 6.78382 8.6308 3.34534 4.88639C3.03894 4.53669 2.49423 4.51795 2.15378 4.84441C1.81334 5.17122 1.77942 5.72075 2.11987 6.07046C5.55836 9.82562 9.50751 13.0132 13.0141 16.6705C13.3545 17.0119 13.8991 17.0168 14.2396 16.6809C14.546 16.3455 14.58 15.7959 14.2396 15.4545Z",
    fill: "#A8C956"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8098 1.4287C20.9119 3.51583 21.0138 5.60295 21.116 7.69042C21.116 8.16849 21.5247 8.53762 22.0013 8.51438C22.4779 8.49079 22.8182 8.08384 22.8182 7.60543C22.7161 5.51483 22.6141 3.42459 22.512 1.33434C22.4779 0.85627 22.0693 0.489566 21.5927 0.515586C21.1501 0.541605 20.7757 0.950983 20.8098 1.4287Z",
    fill: "#A8C956"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight1);
export default __webpack_public_path__ + "static/media/highlight1.7b32088a514fe987cc23383abeb67661.svg";
export { ForwardRef as ReactComponent };